/**
 * @generated SignedSource<<a341e4fc9258c7110870a521607b1634>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type PopupPatternFilterButton_Query$variables = {};
export type PopupPatternFilterButton_QueryVariables = PopupPatternFilterButton_Query$variables;
export type PopupPatternFilterButton_Query$data = {
  readonly sources: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly id: string;
        readonly name: string;
      } | null;
    } | null> | null;
  };
};
export type PopupPatternFilterButton_QueryResponse = PopupPatternFilterButton_Query$data;
export type PopupPatternFilterButton_Query = {
  variables: PopupPatternFilterButton_QueryVariables;
  response: PopupPatternFilterButton_Query$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "SourceConnection",
    "kind": "LinkedField",
    "name": "sources",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "SourceEdge",
        "kind": "LinkedField",
        "name": "edges",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Source",
            "kind": "LinkedField",
            "name": "node",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "name",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "PopupPatternFilterButton_Query",
    "selections": (v0/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "PopupPatternFilterButton_Query",
    "selections": (v0/*: any*/)
  },
  "params": {
    "cacheID": "05670769bee145982dce810486b415b6",
    "id": null,
    "metadata": {},
    "name": "PopupPatternFilterButton_Query",
    "operationKind": "query",
    "text": "query PopupPatternFilterButton_Query {\n  sources {\n    edges {\n      node {\n        id\n        name\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "cbd42fd700126c1004f762a075bf8f7b";

export default node;
